import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=d4e28fbc&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e28fbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4e28fbc')) {
      api.createRecord('d4e28fbc', component.options)
    } else {
      api.reload('d4e28fbc', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=d4e28fbc&scoped=true&", function () {
      api.rerender('d4e28fbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26pe8GTqxa6Ls/JS/comp/Accordion.vue"
export default component.exports